module.exports = __webpack_public_path__ + "static/media/scribd.ad86e46d.svg";